module.exports = __webpack_public_path__ + "assets/img/e28b-rw.svg";